// removed by extract-text-webpack-plugin
module.exports = {"share":"src-components-Share----Share-module---share---3hhFg","share_title":"src-components-Share----Share-module---share_title---28Ih1","share_list":"src-components-Share----Share-module---share_list---1M8c9","share_list_icon":"src-components-Share----Share-module---share_list_icon---3QgS7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Share/Share.module.scss
// module id = 852
// module chunks = 114276838955818